import { Button, Checkbox, Collapse, FormControlLabel, Grid, Typography } from "@mui/material"
import { ReactNode, useState } from "react"
import { LoadingButton } from "@mui/lab"
import SendIcon from '@mui/icons-material/Send';
import { useSlideInContext, useManageModal } from "ui";
import { ChevronLeft } from "@mui/icons-material";
import { StudentDataType } from "ft-shared-graphql";
import { SendToParentProps, TRUESAGE_FILE } from "./SendToParentType";
const TRUESAGE_NORMALIZED_NAMES: Record<TRUESAGE_FILE, string> = {
    'TrueSage_Building_Healthy_Relationships': 'Relationship Help',
    'TrueSage_Coping_With_Stress': 'Managing Stress',
    'TrueSage_Managing_Grief': 'Managing Grief',
    'TrueSage_Managing_Sleep': 'Sleep Strategies'
}
// export type EnlightnOptionsProps = {
//     studentData: StudentDataType,
//     updateStudent: (student: StudentDataType | undefined) => void,
//     onAction:

// }
const EnlightnOptions = ({ onAction }: SendToParentProps) => {
    const [previewInfo, setPreviewInfo] = useState<TRUESAGE_FILE[]>([])
    const [sendDocs, setSendDocs] = useState<TRUESAGE_FILE[]>([]);
    // const { studentData } = useStudentContext()
    const { disableClosingDrawer, toggleDrawer } = useSlideInContext()
    const { openModal } = useManageModal()
    // const accessToken = usePersonAuthStore(state => state.access_token);
    const [launchAction, setLaunchAction] = useState<string | null>(null);
    const handlePreview = async (action: TRUESAGE_FILE) => {
        setPreviewInfo(prevState =>
            prevState?.includes(action)
                ? prevState
                : [...(prevState ?? []), action]
        );
        // const link = document.createElement('a');
        // link.href = `${window.__env.API_URL}/api/file/download/enlightn/${action}`;

        // link.target = "_blank";
        // const linkHandler = () => {
        //     setTimeout(() => {
        //         link.removeEventListener('click', linkHandler);
        //         document.body.removeChild(link);
        //     }, 300)
        // }
        // link.addEventListener('click', linkHandler);
        // document.body.appendChild(link);
        // link.click();
        onAction('preview', action, [])
    }

    const handleSelectToSend = (file: TRUESAGE_FILE) => {
        setSendDocs(prev =>
            prev.includes(file)
                ? prev.filter(i => i !== file)
                : [...prev, file]
        )
    }

    const handleSend = async (action: string) => {
        setLaunchAction(action)
        disableClosingDrawer(true)
        onAction('send', 'TrueSage', sendDocs)
        // const { pid, lid } = decodedToken(accessToken ?? '');
        // var response = await fetch(`${window.__env.API_URL}/api/parent/send/enlightn`, {
        //     method: "post",
        //     headers: {
        //         Pid: pid,
        //         Lid: lid,
        //         "Content-Type": "application/json",
        //         authorization: `Bearer ${accessToken}`,
        //     },
        //     body: JSON.stringify({
        //         personId: pid,
        //         studentId: studentData.id,
        //         files: sendDocs
        //     }),
        // })
        // if (response.status >= 400) {
        //     showFailureMessage();
        //     disableClosingDrawer(false)
        //     setPreviewInfo([]);
        //     setLaunchAction(null)
        //     return;
        // }

        // showSuccessMessage();
        // toggleDrawer()

        // disableClosingDrawer(false)
        // setPreviewInfo([]);
        // setLaunchAction(null)
    }

    return (
        <Grid container spacing={1}
            direction="column" alignItems="center"
            sx={{ padding: "36px 16px", textAlign: "center" }}>
            <Grid size={12} >
                <Typography>Enlightn™ Materials</Typography>
            </Grid>
            <Grid size={12} direction="column" alignItems="center">
                <Button onClick={() => handlePreview("TrueSage_Managing_Sleep")} variant="contained" sx={{ marginTop: "16px", padding: 1 }}>
                    Sleep Strategies
                </Button>
            </Grid>
            <Grid size={12} direction="column" alignItems="center">
                <Button onClick={() => handlePreview("TrueSage_Managing_Grief")} variant="contained" sx={{ marginTop: "16px", padding: 1 }}>
                    Addressing Grief
                </Button>
            </Grid>
            <Grid size={12} direction="column" alignItems="center">
                <Button onClick={() => handlePreview("TrueSage_Coping_With_Stress")} variant="contained" sx={{ marginTop: "16px", padding: 1 }}>
                    Addressing Stress
                </Button>
            </Grid>
            <Grid size={12} direction="column" alignItems="center">
                <Button onClick={() => handlePreview("TrueSage_Building_Healthy_Relationships")} variant="contained" sx={{ marginTop: "16px", padding: 1 }}>
                    Relationship Help
                </Button>
            </Grid>
            <Grid size={12} direction="column" alignItems="center">
                <Collapse in={previewInfo.length > 0}>
                    <Grid size={12} direction="column" alignItems="center">
                        <Typography>Select documents you would like to send. If a file is missing, please use the above buttons to view it first</Typography>
                        {previewInfo.map((file, id) => (
                            <FormControlLabel key={id} control={<Checkbox checked={sendDocs.includes(file)}
                                onChange={() => handleSelectToSend(file)} />}
                                label={TRUESAGE_NORMALIZED_NAMES[file]}
                            />
                        ))}
                    </Grid>
                    <Grid size={12} direction="column" alignItems="center">
                        <LaunchButton action='send' currentAction={launchAction} onAction={handleSend} width={210} disabled={sendDocs.length < 1}>Send to parent</LaunchButton>
                    </Grid>
                </Collapse>
            </Grid>
        </Grid>
    )
}
function LaunchButton({ action: type, currentAction: action, onAction, width = 180, disabled, children }: {
    action: string,
    currentAction: string | null,
    onAction: (action: string) => {}, children: ReactNode,
    width?: number,
    disabled?: boolean
}) {
    return (
        <LoadingButton
            sx={{
                backgroundColor: "primary.main",
                "&:hover": {
                    backgroundColor: "primary.light",
                },
                width,
                marginTop: "16px",
                padding: 1
            }}
            type="submit"
            variant="contained"
            loading={type === action}
            loadingPosition="end"
            disabled={disabled}
            endIcon={<SendIcon />}
            onClick={() => onAction(type)}
        >
            {children}
        </LoadingButton>
    )
}

export default EnlightnOptions